import { useLayoutEffect, useState } from 'react';
import ViewPort from "./Enums/ViewPortEnum";

export default function useWindowSize() {
  const [width, setWidth] = useState<number>(window.innerWidth);
  const [height, setHeight] = useState<number>(window.innerHeight);
  const [breakPoint, setBreakPoint] = useState<number>(getBreakPoint());

  function getBreakPoint(): ViewPort {
    if (window.innerWidth >= 1200) {
      return ViewPort.xl;
    }
    else if (window.innerWidth >= 992) {
      return ViewPort.lg;
    }
    else if (window.innerWidth >= 768) {
      return ViewPort.md;
    }
    else if (window.innerWidth >= 576) {
      return ViewPort.sm;
    }
    else {
      return ViewPort.xs;
    }
  }

  useLayoutEffect(() => {
    function updateSize() {
      setWidth(window.innerWidth);
      setHeight(window.innerHeight);
      setBreakPoint(getBreakPoint());
    }

    window.addEventListener('resize', updateSize);
    return () => window.removeEventListener('resize', updateSize);
  }, []);
  return { width, height, breakPoint }; //size;
}